import { render, staticRenderFns } from "./VideoLayer.vue?vue&type=template&id=8ed906f2&"
import script from "./VideoLayer.vue?vue&type=script&lang=js&"
export * from "./VideoLayer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports